//https://www.gunviolencearchive.org/query/35d04c1e-fd92-40f7-9f1d-560b2adbe4f7
const maxZoom = 11,
      minZoom = 4;

let currentZoom = 4,
    locations = [],
    gMap;

function setZoom(){
    //console.log(gMap.getZoom());
    //alert(gMap.getZoom());
    //

    if (currentZoom >= maxZoom) {
        document.getElementById('link-plus').classList.add('inactive');
    } else {
        document.getElementById('link-plus').classList.remove('inactive');
    }


    gMap.setZoom(currentZoom);
}



function initMap() {
    //alert();
    //
    //
    const googleMapHeight = Math.floor(winH * 0.8);
    document.getElementById('google-map-wrap').style.height = googleMapHeight + 'px';
    document.getElementById('google-map').style.height = (googleMapHeight + 2) + 'px';


    const mapOptions = {
        center: { lat: 30.850033, lng: -93.6500523},
        zoom: 4,
        minZoom: 11,
        minZoom: currentZoom,
        mapId: 'cae2c061f4672a5',
        scrollwheel: false,
        disableDefaultUI: true
    };

    gMap = new google.maps.Map(document.getElementById('google-map'), mapOptions);

    const request = new XMLHttpRequest();
    request.open('GET', '/_assets/data/locations.csv'); //everytown.csv
    request.onreadystatechange = function() {
        if(this.readyState === 4 && this.status === 200) {
            const d = this.responseText;
            const lines = d.split("\n");
            //alert(lines[1]);

            for(i=0; i<lines.length; i++){
                let line = lines[i].split(',');
                if(line[0] && line[1]) {
                    //alert(line[0] +' / '+ line[1]);
                    locations.push({ lat: parseFloat(line[0].replace('"','')), lng: parseFloat(line[1].replace('"','')) });
                }
            }

            const markers = locations.map((location, i) => {
              return new google.maps.Marker({
                position: location,
                icon: "/_assets/img/marker.png"
              });
            });

            const mcOptions = {
                                //imagePath: 'https://googlemaps.github.io/js-marker-clusterer/images/m',
                                styles: [
                                        {
                                            url: "/_assets/img/m1.png",
                                            width: 55,
                                            height: 65,
                                            textSize: 12,
                                            textColor: "#ffffff"
                                        },
                                        {
                                            url: "/_assets/img/m2.png",
                                            width: 66,
                                            height: 80,
                                            textSize: 14,
                                            textColor: "#ffffff"
                                        },
                                        {
                                            url: "/_assets/img/m3.png",
                                            width: 78,
                                            height: 100,
                                            textSize: 16,
                                            textColor: "#ff0000"
                                        }
                                ]
                            };
            //{ imagePath: "//developers.google.com/maps/documentation/javascript/examples/markerclusterer/m"}
            // Add a marker clusterer to manage the markers.
            new MarkerClusterer(gMap, markers, mcOptions);

            if( document.getElementById('link-minus') ){
                document.getElementById('link-minus').addEventListener('click', function(e){
                    if(this.classList.contains('inactive') == false) {
                        const zoom = gMap.getZoom();
                        currentZoom = zoom - 1;
                        //console.log(zoom);
                        if (currentZoom <= minZoom) {
                            currentZoom = minZoom;
                            document.getElementById('link-minus').classList.add('inactive');
                        } else {
                            document.getElementById('link-plus').classList.remove('inactive');
                        }
                        // else {
                        //    document.getElementById('link-minus').classList.remove('inactive');
                        //}

                        setZoom();
                    }
                    e.preventDefault();
                });
            }

            if( document.getElementById('link-plus') ){
                document.getElementById('link-plus').addEventListener('click', function(e){
                    //alert(this.classList.contains('inactive'));
                    if(this.classList.contains('inactive') == false) {
                        const zoom = gMap.getZoom();
                        currentZoom = zoom + 1;
                        //console.log(zoom);
                        if (currentZoom >= maxZoom) {
                            currentZoom = maxZoom;
                            document.getElementById('link-plus').classList.add('inactive');
                        } else {
                            document.getElementById('link-minus').classList.remove('inactive');
                        }
                        setZoom();
                    }
                    e.preventDefault();
                });
            }

            //for(var i=0; i<array.length; i++){}
        }
    };
    request.send();

}
